/**
 * App — root component.
 *
 * Hosts the global pieces that need to live above the route tree:
 *   - <BrowserRouter> — react-router top
 *   - <AppRoutes>     — route declarations
 *   - <Toaster>       — global toast queue (ALL feedback goes through this)
 *   - <ConfirmHost>   — imperative confirm() dialog host
 *
 * Anything that needs to be addressable from anywhere in the app
 * (toasts, confirms) is mounted exactly once here.
 */
import { BrowserRouter } from "react-router-dom";

import AppRoutes      from "./routes/AppRoutes";
import Toaster        from "./components/Toaster";
import { ConfirmHost } from "./components/ConfirmDialog";

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <Toaster />
      <ConfirmHost />
    </BrowserRouter>
  );
}
